import { createContext } from 'react';

import { LIQUID_STAKING_TOKEN_ADDRESS } from 'modules/api/const';

export const LiquidStakingPoolContext = createContext(
  LIQUID_STAKING_TOKEN_ADDRESS,
);
